<template>
  <div class="footer-wrap">
    <div v-show="visible" class="footer-phone">
      <div v-for="(item, index) in footerData" :key="index" class="footer-phone-title">
        <div @click="showNavList(item)">
          <span> {{ item.name }}</span>
          <i :class="['footer-arrow', item.arrow]"></i>
        </div>
        <slider>
          <div v-show="item.isSubShow" class="collapse-wrap">
            <div v-for="(val, key) in item.children" v-show="item.isSubShow" :key="key" class="footer-phone-list">
              <a :href="val.url">
                {{ val.name }}
              </a>
            </div>
          </div>
        </slider>
      </div>
      <div class="footer-phone-contact">
        <div class="phone">
          <div class="tel">95018</div>
          <div class="tel-txt">24 小时全国热线</div>
        </div>
        <div class="social-icon">
          <img src="../assets/common/weibo.png" @click="gotoWeibo" />
          <img src="../assets/common/wechat.png" @click="showWeChat = true" />
        </div>
      </div>
      <div class="footer-phone-word">
        <div>
          Copyright © OPPO 广东移动通信有限公司 2004- 2020. All Rights Reserved. 网站备案号 :
          <a href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备08130115号-9</a><br />
          <a
            href="http://www.oppo.com/cn/service/help/640?id=640&amp;name=%E6%9C%8D%E5%8A%A1%E6%94%BF%E7%AD%96&amp;hdscreen=1"
            >隐私政策</a
          >&nbsp;|&nbsp;
          <a href="https://www.coloros.com/about.html">关于我们</a>
        </div>
        <div class="global">
          <img class="gloabal-icon" src="../assets/common/global-icon.png" />
          <a href="https://www.coloros.com/en/global">Global</a>
        </div>
      </div>
      <div v-show="showWeChat" class="diagoWeChat" @click="showWeChat = false">
        <img src="../assets/common/wechat-code.png" />
      </div>
    </div>

    <div v-show="!visible" class="footer-pc">
      <div class="nav-container">
        <div class="footer-pc-nav">
          <ul v-for="(item, index) in footerData" :key="index" class="nav-ul">
            <li class="title">{{ item.name }}</li>
            <li v-for="(val, key) in item.children" :key="key" class="nav-li">
              <a :href="val.url">
                {{ val.name }}
              </a>
            </li>
          </ul>
        </div>
        <div class="footer-pc-contact">
          <div class="tel">95018</div>
          <div class="tel-txt">24 小时全国热线</div>
          <div class="social-icon">
            <a class="weixin-icon">
              <div class="qrcodeimg">
                <img src="../assets/common/wechat-code.png" />
                <p>扫一扫关注</p>
              </div>
            </a>

            <a href="http://weibo.com/colorrom" target="_blank" class="weibo-icon"></a>
          </div>
        </div>
      </div>

      <div class="footer-pc-word">
        <div>
          Copyright © OPPO 广东移动通信有限公司 2004- 2020. All Rights Reserved. 网站备案号 :
          <a href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备08130115号-9</a>&nbsp;|&nbsp;
          <a href="http://www.oppo.com/cn/service/help/640?id=640&name=%E6%9C%8D%E5%8A%A1%E6%94%BF%E7%AD%96&hdscreen=1"
            >隐私政策</a
          >&nbsp;|&nbsp;
          <a href="https://www.coloros.com/about.html">关于我们</a>
        </div>
        <div class="global">
          <img class="gloabal-icon" src="../assets/common/global-icon.png" />
          <a href="https://www.coloros.com/en/global">Global</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import slider from '@/util/slider';
import footerData from '@/util/footerData';
export default {
  components: { slider },
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      footerData,
      showWeChat: false
    };
  },

  methods: {
    //底部导航
    showNavList(value) {
      console.log(value);
      let index = value.index;
      if (this.footerData[index].isSubShow) {
        this.footerData[index].isSubShow = false;
        this.footerData[index].arrow = '';
      } else {
        this.footerData.forEach(item => {
          item.isSubShow = false;
          item.arrow = '';
        });
        this.footerData[index].isSubShow = true;
        this.footerData[index].arrow = 'open';
      }
    },

    gotoWeibo() {
      location.href = 'http://weibo.com/colorrom';
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-wrap {
  width: 100%;
  box-sizing: border-box;
  text-align: left;
}
.footer-phone {
  background-color: #ffffff;
  padding: 0 20px;
  &-title {
    line-height: 50px;
    font-size: 14px;
    overflow: hidden;
    position: relative;
    .footer-arrow {
      position: absolute;
      top: 22.5px;
      right: 0;
      width: 9px;
      height: 5px;
      background: url('../assets/common/footer_arrow.png') no-repeat center;
      background-size: contain;
    }
    .open {
      transform: rotate(180deg);
    }
  }
  &-list {
    font-size: 12px;
    line-height: 40px;
    color: #555;
    a {
      width: 100%;
      display: inline-block;
      color: #555;
      text-decoration: none;
    }
  }

  &-contact {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
    .phone {
      //overflow: hidden;
      .tel {
        font-variation-settings: 'wght' 750;
        font-size: 24px;
        color: #000;
        line-height: 50px;
      }
      .tel-txt {
        font-size: 14px;
        color: #252525;
        letter-spacing: 2px;
        line-height: 24px;
      }
    }

    .social-icon {
      img {
        display: inline-block;
        width: 40px;
        margin-left: 15px;
      }
    }
  }
  &-word {
    margin-top: 40px;
    padding-top: 20px;
    padding-bottom: 40px;
    border-top: 1px solid #eee;
    color: #bbb;
    font-size: 13px;
    line-height: 17px;
    a {
      color: #bbbbbb;
      text-decoration: none;
    }
    .global {
      margin-top: 22px;
      color: #999;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .gloabal-icon {
        display: inline-block;
        width: 16px;
        margin-right: 10px;
      }
      a {
        display: block;
        color: #999;
        text-decoration: none;
      }
    }
  }
  .diagoWeChat {
    background: rgba(0, 0, 0, 0.8);
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      display: inline-block;
      width: 250px;
      z-index: 3000;
    }
  }
}

.footer-pc {
  /* width: 1600px; */
  margin: 0 auto;
  .nav-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 80px 140px;
  }
  &-nav {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 800px;
    .nav-ul {
      .title {
        font-size: 16px;
        color: #000;
        letter-spacing: 0.67px;
        line-height: 23px;
        margin-bottom: 15px;
        font-variation-settings: 'wght' 750;
      }
    }
    .nav-li {
      font-size: 14px;
      color: #555;
      letter-spacing: 0;
      line-height: 32px;
      a {
        color: #555;
        text-decoration: none;
      }
    }
  }
  &-contact {
    width: 320px;
    height: 150px;
    text-align: right;
    .tel {
      font-size: 32px;
      color: #000;
      letter-spacing: 0;
      margin-bottom: 17px;
      font-variation-settings: 'wght' 750;
    }
    .tel-txt {
      font-size: 14px;
      color: #555;
      letter-spacing: 2px;
      line-height: 26px;
    }
    .social-icon {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      position: relative;
      .weixin-icon {
        background: url('../assets/common/wechat.png') no-repeat center;
        background-size: contain;
        width: 40px;
        height: 40px;
        margin-right: 15px;
        display: inline-block;
        cursor: pointer;
        .qrcodeimg {
          display: none;
          width: 148px;
          text-align: center;
          position: absolute;
          right: 110px;
          top: -50px;
          font-size: 12px;
          color: #000;
          box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
          border-radius: 6px;
          img {
            width: 120px;
            display: inline-block;
            margin-top: 12px;
          }
          p {
            line-height: 32px;
          }
        }
      }
      .weixin-icon:hover {
        background: url('../assets/common/wechat-hover.png') no-repeat center;
        background-size: contain;
      }
      .weixin-icon:hover .qrcodeimg {
        display: block;
      }
      .weibo-icon {
        background: url('../assets/common/weibo.png') no-repeat center;
        background-size: contain;
        width: 40px;
        height: 40px;
        display: inline-block;
      }
      .weibo-icon:hover {
        background: url('../assets/common/weibo-hover.png') no-repeat center;
        background-size: contain;
      }
    }
  }
  &-word {
    color: #bbbbbb;
    min-height: 94px;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #eee;
    padding: 0 140px;
    a {
      color: #bbbbbb;
      text-decoration: none;
    }
    .global {
      color: #999;
      font-size: 14px;
      line-height: 24px;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .gloabal-icon {
        display: inline-block;
        width: 14px;
        margin-right: 10px;
      }
      a {
        display: block;
        color: #999;
        text-decoration: none;
      }
    }
  }
}
</style>
